// extracted by mini-css-extract-plugin
export default {"wrapper":"src-views-debug-DebugSDSButtons-DebugSDSButtons__wrapper--qOl5G"};